import { render } from "./ModalFigli.vue?vue&type=template&id=5d60e4ea&ts=true"
import script from "./ModalFigli.vue?vue&type=script&lang=ts"
export * from "./ModalFigli.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__